import { Injectable, Component, Input, NgModule, defineInjectable } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
class NgxFlagIconCssService {
    constructor() { }
}
NgxFlagIconCssService.ɵfac = function NgxFlagIconCssService_Factory(t) { return new (t || NgxFlagIconCssService)(); };
NgxFlagIconCssService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgxFlagIconCssService, factory: NgxFlagIconCssService.ɵfac, providedIn: 'root' });
/** @nocollapse */
NgxFlagIconCssService.ctorParameters = () => [];
/** @nocollapse */ NgxFlagIconCssService.ngInjectableDef = defineInjectable({ factory: function NgxFlagIconCssService_Factory() { return new NgxFlagIconCssService(); }, token: NgxFlagIconCssService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxFlagIconCssService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class NgxFlagIconCssComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.squared = (this.squared != undefined);
    }
    /**
     * @return {?}
     */
    addingFlagClasses() {
        return `flag-icon flag-icon-${this.country} ${this.squared ? 'flag-icon-squared' : ''}`;
    }
}
NgxFlagIconCssComponent.ɵfac = function NgxFlagIconCssComponent_Factory(t) { return new (t || NgxFlagIconCssComponent)(); };
NgxFlagIconCssComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxFlagIconCssComponent, selectors: [["flag-icon"]], inputs: { squared: "squared", country: "country" }, decls: 1, vars: 1, consts: [[3, "ngClass"]], template: function NgxFlagIconCssComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "span", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.addingFlagClasses());
    } }, directives: [ɵngcc1.NgClass], encapsulation: 2 });
/** @nocollapse */
NgxFlagIconCssComponent.ctorParameters = () => [];
NgxFlagIconCssComponent.propDecorators = {
    country: [{ type: Input }],
    squared: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxFlagIconCssComponent, [{
        type: Component,
        args: [{
                selector: 'flag-icon',
                template: `
    <span [ngClass]="addingFlagClasses()"></span>
  `,
                styles: []
            }]
    }], function () { return []; }, { squared: [{
            type: Input
        }], country: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class NgxFlagIconCssModule {
}
NgxFlagIconCssModule.ɵfac = function NgxFlagIconCssModule_Factory(t) { return new (t || NgxFlagIconCssModule)(); };
NgxFlagIconCssModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxFlagIconCssModule });
NgxFlagIconCssModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxFlagIconCssModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [NgxFlagIconCssComponent],
                exports: [NgxFlagIconCssComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxFlagIconCssModule, { declarations: function () { return [NgxFlagIconCssComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxFlagIconCssComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { NgxFlagIconCssService, NgxFlagIconCssComponent, NgxFlagIconCssModule };

